/*
 * @Author: libo 
 * @Date: 2020-12-01 14:46:47 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-05-19 10:51:34
 */

<!-- 缴费记录页面 -->
<template>
<div class="card-container">
  <a-tabs v-model="activeKey">
    <a-tab-pane :key="1" :tab="$t('营收对账详情列表')">
<a-row :gutter="24">
    <!--
  <a-col :md="collapsed? 0: 5" :sm="24">
    <a-card :bordered="false">
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              当前选择：<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">取消选择</a>
            </div>
          </a-alert>
          <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" allowClear placeholder="请输入区域名称"/>
          <!-- 树-->
          <!--
          <a-col :md="24" :sm="24">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
              </a-spin>
            </template>
          </a-col>
        </div>
    </a-card>
  </a-col>
  -->
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px">
      <!--
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed"></a-icon>
      -->
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编号')">
              <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('对账状态')">
                <a-select  v-model="queryParam.checkState" :placeholder="$t('请选择对账状态')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                  <a-select-option :value="1">
                    {{ $t('异常') }}
                  </a-select-option>
                  <a-select-option :value="0">
                    {{ $t('正常') }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('交易设备')">
                <a-select  v-model="queryParam.deviceType" :placeholder="$t('请选择交易设备')">
                  <a-select-option v-for="(item,value) in deviceTypeObj" :value="value" :key="value">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('交易流水号')">
                <a-input :placeholder="$t('请输入交易流水号')" v-model="queryParam.tradeId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('订单编号')">
                <a-input :placeholder="$t('请输入订单编号')" v-model="queryParam.orderId"></a-input>
              </a-form-item>
            </a-col>
            <!--
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="用水价格">
                <a-input placeholder="请输入用水价格名字 用水性质" v-model="queryParam.userPriceName"></a-input>
              </a-form-item>
            </a-col>
            -->
            <a-col :xl="12" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('交易起止时间')">
                <a-range-picker
                  v-model="date"
                  format="YYYY-MM-DD"
                  :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                  @change="onDateRangeChange"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls($t('收费对账记录'))">{{ $t('导出') }}</a-button>
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- 汇总显示 -->
    <!--
    <a-descriptions :column="4">
      <a-descriptions-item label="记录条数">{{summarizing.sumCount}}</a-descriptions-item>
      <a-descriptions-item label="累计充值金额">¥{{towNumber(summarizing.sumPayNum)}}</a-descriptions-item>
      <a-descriptions-item label="累计退水金额">¥{{towNumber(summarizing.sumBackNum)}}</a-descriptions-item>
      <a-descriptions-item label="累计补水金额">¥{{towNumber(summarizing.sumMakeUpNum)}}</a-descriptions-item>
    </a-descriptions>
    -->
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
        <span style="float:right;">
          <a @click="loadData()"><a-icon type="sync" />{{ $t('刷新') }}</a>
          <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
            <template slot="content">
              <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                <a-row>
                  <template v-for="item in defColumns">
                    <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                      <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                    </template>
                  </template>
                </a-row>
              </a-checkbox-group>
            </template>
          </a-popover>
        </span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <div slot="filterDropdown">
          <a-card>
            <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
              <a-row>
                <template v-for="item in defColumns">
                  <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                    <a-col :span="12" :key="item.key">
                      <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                    </a-col>
                  </template>
                </template>
              </a-row>
            </a-checkbox-group>
          </a-card>
        </div>
        <span slot="checkStateSlot" slot-scope="text, record">
            <span v-if="record.checkState === 0" style="color: green">{{ $t('对账正常') }}</span>
            <span v-else style="color: red">{{ $t('对账异常') }}</span>
        </span>
        <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
  </a-card>
  </a-col>
</a-row>
</a-tab-pane>
    <a-tab-pane :key="2" :tab="$t('对账任务列表')">
     <meter-the-batch-tash-comp :taskType="7"></meter-the-batch-tash-comp>
    </a-tab-pane>
  </a-tabs>
</div>
</template>

<script>
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import { httpAction,getAction } from '@/api/manage'
  import { listSize } from '@/utils/util'
  import {isUndefined,isNull} from'@/utils/validate'
  import Vue from 'vue'
  import {deviceTypeObj} from '@/utils/constants/commonConstant'
  import meterTheBatchTashComp from '@/views/meterManagement/meterTheBatchTashComp'

  export default {
    name: 'MeterUserPayRecordCheckList',
    mixins:[JeecgListMixin, mixinDevice, AreaChoosetMixin],
    components: {
        meterTheBatchTashComp
    },
    data () {
      return {
        description: 'meter_user_pay_check_record管理页面',
        collapsed: true,
        deviceTypeObj,
        //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          user: "/sys/user/list",  //操作员列表
          list: "/jeecg-charge/meter/meterUserPayRecordCheck/list",
          delete: "/jeecg-charge/meter/meterUserPayRecordCheck/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserPayRecordCheck/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUserPayRecordCheck/exportXls",  //导出接口
          importExcelUrl: "jeecg-charge/meter/meterUserPayRecordCheck/importExcel",
          doPayCancleTask:"/jeecg-charge/meter/meterUserPayRecord/doPayCancleTask",   //撤销
          doPayUncancleTask:"/jeecg-charge/meter/meterUserPayRecord/doPayUncancleTask", 
          sumResult:"/jeecg-charge/meter/meterUserPayRecord/sumResult"  //缴费记录汇总报表
        },
        dictOptions:{},
        endOpen: false,
        date:[],
        summarizing:{},  //缴费记录汇总报表
        /*item:{
        id:'',
        userKeyId:'',
        },*/
        userArray:[],  //操作员
        dateType: 2,
        userAccountPayType: [],
        activeKey: 1
      }
    },
    created() {
      this.loadData(1);
      this.initColumns();
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'meterUserId'
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },
          {
            title: this.$t('交易设备'),
            align:"center",
            dataIndex: 'deviceType',
            customRender:(t,r,index) => {
              let obj = deviceTypeObj
              if(!isUndefined(obj[t])) {
                return this.$t(obj[t])
              }
              return this.$t('未知')
            }
          },
          {
            title: this.$t('交易流水号'),
            align:"center",
            dataIndex: 'tradeId'
          },
          {
            title: this.$t('商品订单号'),
            align:"center",
            dataIndex: 'orderId'
          },
          {
            title: this.$t('账单日期'),
            align:"center",
            dataIndex: 'tradeDate',
            customRender:(t,r,index) => {

                return r.tradeDateTime.substr(0,10)
            }
          },
          {
            title: this.$t('交易时间'),
            align:"center",
            dataIndex: 'tradeDateTime'
          },
          {
            title: this.$t('对账状态'),
            align:"center",
            dataIndex: 'checkState',
            scopedSlots: { customRender: 'checkStateSlot' }
          },
          {
            title: this.$t('对账结果'),
            align:"center",
            dataIndex: 'checkDetail',
            customRender:(t,r,index) => {
              if(r.checkState === 0) {
                return this.$t("对账正常")
              }
              return r.checkDetail
            }
          },
          {
            title: this.$t('对账时间'),
            align:"center",
            dataIndex: 'createTime',
            customRender:(t,r,index) => {
              if(!isNull(r.updateTime)&&r.updateTime!="") {
                return r.updateTime
              }
              return t
            }
          },
          {
            title: this.$t('对账员'),
            align:"center",
            dataIndex: 'createBy',
            customRender:(t,r,index) => {
              if(!isNull(r.updateBy)&&r.updateBy!="") {
                return r.updateBy
              }
              return t
            }
          },
          /*
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:80,
            scopedSlots: { customRender: 'action' }
          }*/
        ]
      },
    },
    methods: {
      loadListData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t('请设置url.list属性!'))
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      queryUserList() {   //操作员请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.user, params).then((res) => {
          if(res.success){
            this.userArray = res.result.records;
          }
        }) 
      },
      querysumResult() {   //缴费记录汇总报表
        let params = this.getQueryParams();//查询条件
        console.log(params)
        getAction(this.url.sumResult, params).then((res) => {
          if(res.success ){
            this.summarizing = res.result;
          }
        })
      },
      towNumber(val) {    //保留两位小数  
        if (!val) {
          return 0;
        }
        return val.toFixed(2);  
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      handleChange(value) {
        this.queryParam.userAccountPayType = value +"";
      },
      loadData(arg) {
          this.loadTree();
        this.querysumResult();
        this.loadListData(arg);
      },
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadListData();
      },
      searchReset() {
        this.queryParam = {}
        this.resetAareaData()
        this.date = []
        this.userAccountPayType = []
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .card-container {
  overflow: hidden;
}
.card-container /deep/ .ant-tabs-content {
  margin-top: -16px;
}
.card-container /deep/ .ant-tabs-bar {
  background-color: #fff;
}

.card-container /deep/  .ant-tabs-content  .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container /deep/  .ant-tabs-bar {
}

.card-container /deep/  .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container /deep/ .ant-tabs-bar .ant-tabs-tab-active {
  background: #fff;
}
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>